import types from './types';

const initialState = {
  isLoading: true,
  user: null,
  sessionInterval: 0,
};

export default (
  state = initialState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.SESSION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sessionInterval: data,
      };
    case types.SESSION_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case types.START_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case types.START_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
